export default "__VITE_ASSET__bc658eaf__"